import React from "react";
import Stack from "@mui/material/Stack";
import {useMediaQuery} from "react-responsive";
import classnames from "classnames";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import Typography from "@mui/material/Typography";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import {useDealContext} from "../../contexts/DealContext";
import {PopoverInput} from "../../components/PopoverInput";
import EditLocationAltOutlinedIcon from '@mui/icons-material/EditLocationAltOutlined';
import Tooltip from "@mui/material/Tooltip";
import {LocationModal} from "./LocationModal";
import {useModalsStore} from "../../stores/modalsStore";
import {useShallow} from "zustand/react/shallow";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import _ from "lodash";

export const DealPageInfo = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { updateDealResponse, dealState, setDealStateWithoutQuoteUpdate, setDealStateWithUpdate, dealColorLight } = useDealContext()

    const {
        openModal,
        closeModalById,
    } = useModalsStore(
        useShallow((state) => ({
            openModal: state.openModal,
            closeModalById: state.closeModalById,
        }))
    )

    const saveDealLocation = (location, shouldSetCustomerLocation, shouldSetDealerLocation) => {
        closeModalById("LocationModal")
        const formatted_quote = structuredClone(dealState).formatted_quote
        if (location.state !== dealState.state) {
            formatted_quote.fees = []
            formatted_quote.rebates = []
        }

        let updateObj = {}

        if (shouldSetCustomerLocation) {
            updateObj = {
                address_line_one: location.address_line_one,
                address_line_two: location.address_line_two,
                city: location.city,
                state: location.state,
                zipcode: location.zipcode,
                county: location.county,
                formatted_quote: formatted_quote
            }
        }
        if (shouldSetDealerLocation) {
            updateObj = {
                ...updateObj,
                dealer_location: location,
                dealer_location_id: location.id,
                dealer_address_line_one: location.address_line_one,
                dealer_address_line_two: location.address_line_two,
                dealer_city: location.city,
                dealer_state: location.state,
                dealer_zipcode: location.zipcode,
                dealer_county: location.county
            }
        }
        if (!_.isEmpty(updateObj)) {
            setDealStateWithUpdate(updateObj, true)
        }
    }

    const car = dealState.car_detail
    const isLoading = updateDealResponse?.loading
    const isPurchase = dealState.is_purchase

    return (
        <Stack
            className={'DealPageInfo_box-container'}
            direction={isTabletOrMobile ? 'column' : 'row'}
            justifyContent="space-between"
            alignItems="center"
        >
            <Stack
                className={'DealPageInfo_box'}
                direction="column"
                justifyContent="space-between"
                alignItems="start"
            >
                <Typography
                    variant="h5"
                    component="div"
                    className={'header-title'}
                    sx={{
                        fontSize: '24px',
                        fontWeight: 'bold',
                    }}
                >
                    {car.year} {car.make} {car.model}{car.is_new ? " " : " [Used] "}
                    <Typography
                        variant="subtitle1"
                        component="span"
                        className={'header-subtitle'}
                    >
                        {car.trim}

                        <Typography
                            fontWeight={400}
                            variant="span"
                            gutterBottom
                            style={{
                                fontSize: '10px'
                            }}
                        >
                            {" "}[{car.manufacture_code}]
                        </Typography>
                    </Typography>
                    {
                        Boolean(dealState?.car_detail.option_codes.length) &&
                        <Typography
                            component="div"
                            sx={{
                                fontSize: '12px',
                            }}
                        >
                            <span>Options: </span>
                            <Select
                                onClose={(e) => {
                                    setTimeout(() => {
                                        if (document.activeElement) {
                                            document.activeElement.blur();
                                        }
                                        document.body.focus();
                                        document.body.blur();
                                    }, 0);
                                }}
                                className={'DealPageInfo_select-input'}
                                multiple={true}
                                value={dealState?.option_code_ids}
                                disabled={dealState?.loading}
                                onChange={(e) => {
                                    const option_code_ids = e.target.value

                                    setDealStateWithUpdate({
                                        option_code_ids: option_code_ids,
                                    })
                                }}
                            >
                                {
                                    dealState?.car_detail.option_codes?.map((option) => <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>)
                                }
                            </Select>
                        </Typography>
                    }
                    <Typography
                        component="div"
                        sx={{
                            fontSize: '12px',
                        }}
                    >
                        <span>Vin: </span>
                        <input
                            className=""
                            type="text"
                            value={dealState.vin}
                            placeholder={'Add Vin'}
                            onChange={(e) => setDealStateWithoutQuoteUpdate({...dealState, vin: e.target.value})}
                        />
                    </Typography>
                    <Divider className={'divider'} sx={{marginBottom: '10px'}}/>
                </Typography>

                <PopoverInput
                    inputProps={{
                        autoFocus: false,
                        placeholder: isLoading ? '' : 'Description',
                        className: 'DealPageInfo_input'
                    }}
                    spellCheck={!isLoading}
                    className={classnames('DealPageInfo_description', {
                        loading: isLoading
                    })}
                    id="txtArea"
                    rows="8"
                    cols="40"
                    onChange={(text) => setDealStateWithUpdate({description: text})}
                    onEnter={(text) => {
                        if (!isLoading) {
                            setDealStateWithoutQuoteUpdate({description: text})
                        }
                    }}
                    value={dealState?.description || ''}
                    placeholder={isLoading ? '' : 'Description'}
                />
            </Stack>

            <Box className={classnames('DealPageInfo_box', {
                isPurchase: isPurchase
            })}>
                <Typography
                    gutterBottom
                    variant="h6"
                    component="div"
                        className={classnames('header location-info', {
                            isPurchase: isPurchase
                        })}
                        sx={{
                            fontSize: '24px',
                            fontWeight: 'bold',
                            marginBottom: '10px',
                        }}
                    >
                        <span>Location</span>
                        <Tooltip title="Edit Location" arrow placement={'top'}>

                            <EditLocationAltOutlinedIcon
                                sx={{color: dealColorLight()}}
                                className={'action-icon EditLocationIcon'}
                                onClick={() => {
                                    openModal({
                                        element: LocationModal,
                                        id: "LocationModal",
                                        props: {
                                            selectLocation: saveDealLocation,
                                            isSaving: updateDealResponse?.loading,
                                        }
                                    })
                                }}
                            />
                        </Tooltip>
                    </Typography>
                    <Divider className={'divider'}/>
                    <Stack
                        className={''}
                        direction={'row'}
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{
                            fontSize: '14px',
                            color: '#666',
                            marginBottom: '5px'
                        }}
                    >
                        <label
                            style={{
                                fontSize: '14px',
                                color: '#666',
                                marginRight: '5px'
                            }}
                        >
                            Customer:
                        </label>
                        <Typography sx={{ fontSize: '14px'}}>
                            { dealState.county }, { dealState.state }, { dealState.zipcode }
                        </Typography>
                    </Stack>

                    <Stack
                        className={''}
                        direction={'row'}
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{
                            fontSize: '14px',
                            color: '#666'
                        }}
                    >
                        <label
                            style={{
                                fontSize: '14px',
                                color: '#666',
                                marginRight: '5px'
                            }}
                        >
                            Dealer:</label>
                        <Typography sx={{ fontSize: '14px'}}>
                            { dealState.dealer_county }, { dealState.dealer_state }, { dealState.dealer_zipcode }
                        </Typography>
                    </Stack>
                </Box>
        </Stack>
    )
}